import { getUserSession } from 'ui-smartforce-settings';
import { apiGet } from '../Helpers';
import {
  InitiativesDashboardResponse,
  InitiativesTotals
} from '../Models/InitiativeValue';
import { APP_CONTACTS_API_BASE_URL } from '../Constants/Url';

export const getInitiativesReports =
  async (): Promise<InitiativesDashboardResponse> => {
    const url = `${APP_CONTACTS_API_BASE_URL}/initiatives/reports?limit=5`;
    const token = getUserSession().access_token;

    return apiGet<InitiativesDashboardResponse>(url, token);
  };

export const getNextInitiativesReports = async (
  url: string
): Promise<InitiativesDashboardResponse> => {
  return apiGet(url, getUserSession().access_token);
};

export const getTotals = async (): Promise<InitiativesTotals> => {
  const url: string = `${APP_CONTACTS_API_BASE_URL}/initiatives/calculate-totals`;
  return apiGet(url, getUserSession().access_token);
};
